import Vue from 'vue'
import Vuex from 'vuex'
import config from './config'

var targetConf = process.env.NODE_ENV
if (targetConf === undefined) {targetConf = 'test'}

Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
    info: {
      version: config[targetConf].version
    },
    hospital: {
      id: 0,
      code: '',
      name: '',
      isHierarchyGroupEnabled: false,
      isConference: false,
      useFederation: false,
      enableStandardPhone: false
    },
    user: {
      name: '',
      privilege: 0
    },
    organization: {
      startAt: '',
      historyId: 0
    },
    deletedSwitch: {
      isDisable: false
    },
    userSearch: {
      sortKey: '',
      searchKey: '',
      searchProfession: '',
      searchProfessionText: '',
      searchAffiliation: '',
      searchDescription: '',
      searchPrivilege: '',
      currentIndex: 0,
    },
    iconDisplayConditions: {
      sortKey: '',
      currentIndex: 0,
      searchKey: ''
    },
    contactSearch: {
      searchKey: '',
      currentIndex: 0,
    },
    standardPhoneSearch: {
      searchKey: '',
      currentIndex: 0,
    },
    folderSearch: {
      searchKey: '',
      currentIndex: 0,
    },
    contact: {
      extraContactId: 0,
      isHierarchyGroupEnabled: false
    },
    auth: {
      isLogIn: false,
      realms: '',
      accsessToken: '',
      idToken: '',
      refreshToken: '',
      subject: '',
      privilege: '',
    },
    excludedUserData: []
  },
  getters: {
    info(state) { 
      return state.info 
    },
    hospital(state) { 
      return state.hospital 
    },
    user(state) { 
      return state.user 
    },
    organization(state) { 
      return state.organization 
    },
    deletedSwitch(state) { 
      return state.deletedSwitch
    },
    userSearch(state) { 
      return state.userSearch
    },
    iconDisplayConditions(state) { 
      return state.iconDisplayConditions
    },
    contactSearch(state) { 
      return state.contactSearch
    },
    standardPhoneSearch(state) { 
      return state.standardPhoneSearch
    },
    folderSearch(state) { 
      return state.folderSearch
    },
    contact(state) {
      return state.contact
    },
    auth(state) {
      return state.auth
    },
    excludedUserData(state) {
      return state.excludedUserData;
    }
  },
  mutations: {
    ['hospital'] (state, payload) {
      state.hospital = payload
    },
    ['user'] (state, payload) {
      state.user = payload
    },
    ['organization'] (state, payload) {
      state.organization = payload
    },
    ['deletedSwitch'] (state, payload) {
      state.deletedSwitch = payload
    },
    ['userSearch'] (state, payload) {
      state.userSearch = payload
    },
    ['iconDisplayConditions'] (state, payload) {
      state.iconDisplayConditions = payload
    },
    ['contactSearch'] (state, payload) {
      state.contactSearch = payload
    },
    ['standardPhoneSearch'] (state, payload) {
      state.standardPhoneSearch = payload
    },
    ['folderSearch'] (state, payload) {
      state.folderSearch = payload
    },
    ['contact'] (state, payload) {
      state.contact = payload
    },
    ['auth'] (state, payload) {
      state.auth = payload
    },
    ['excludedUserData'] (state, payload) {
      state.excludedUserData = payload
    }
  }
})

export default store
